import { FC } from 'react'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { refetchFunc } from 'modules/domain/common/hooks'
import { Deal } from 'modules/domain/deal/types'
import { useAFormHandler } from 'analytics/hooks'
import { useFormik } from 'formik'
import { InputWrapper } from '../../../styled'
import { AButton } from 'views/components/Analytics'
import { FormRadio } from 'views/components/form/FormRadio'
import { RadioItem } from '@agro-club/agroclub-shared'
import { FormLabel, SmallRadioText } from '../../styled'

type LogisticBodyProps = {
  deal: Deal
  showSellerOverload: boolean
  dealRefetch: refetchFunc
  onClose: () => void
}

export const OverloadForm: FC<LogisticBodyProps> = ({ deal, dealRefetch, showSellerOverload, onClose }) => {
  const { t } = useTranslation('deal')
  const { formHandler, formProgress } = useAFormHandler('approveLogistics', { id: deal?.id })

  const formik = useFormik({
    initialValues: {
      customer_overload: deal.customer_overload,
      seller_overload: deal.seller_overload,
    },
    onSubmit: formHandler(
      async () => {
        let data
        if (showSellerOverload) {
          data = formik.values
        } else {
          data = { customer_overload: formik.values.customer_overload }
        }
        await apiClient.patch(endpoints.setOverload(parseInt(deal.id)), data)
      },
      {
        onSuccess: async () => {
          await dealRefetch()
          onClose()
        },
        onError: (error) => {
          const { errors } = error
          formik.setErrors(errors)
        },
      },
    ),
  })
  return (
    <>
      <InputWrapper>
        <FormRadio
          label={<FormLabel>{t('contractSign.overloadTrader')}</FormLabel>}
          formik={formik}
          field="customer_overload"
          labelHeight="small"
          labelWidth={236}
        >
          <RadioItem value={false} label={<SmallRadioText>{t('address:overLoadTypes.normal')}</SmallRadioText>} />
          <RadioItem value={true} label={<SmallRadioText>{t('address:overLoadTypes.full')}</SmallRadioText>} />
        </FormRadio>
        {showSellerOverload && (
          <FormRadio
            label={<FormLabel>{t('contractSign.overloadDC')}</FormLabel>}
            formik={formik}
            field="seller_overload"
            labelHeight="small"
            labelWidth={236}
          >
            <RadioItem value={false} label={<SmallRadioText>{t('address:overLoadTypes.normal')}</SmallRadioText>} />
            <RadioItem value={true} label={<SmallRadioText>{t('address:overLoadTypes.full')}</SmallRadioText>} />
          </FormRadio>
        )}
      </InputWrapper>

      <AButton
        id="contactSignApprove"
        onClick={() => formik.submitForm()}
        color="primary"
        size="medium"
        progress={formProgress}
      >
        {t('common:save')}
      </AButton>
    </>
  )
}
